/**
 * Texts for Support page
 */
export const supportPageText = {
    title: 'Apoio - CamAPS FX',
    titleMeta: 'Disponibilizamos um amplo apoio à utilização do CamAPS FX',
    descriptionMeta: 'Disponibilizamos materiais de apoio, incluindo manuais do utilizador, orientações para descarregamento, webinars e apoio ao cliente por telefone e e-mail.',
    keywords:
        'apoio camaps, apoio camaps fx, ' +
        '',
    localeMeta: 'pt_PT',

    needHelp: 'Precisa de ajuda?',
    needHelpResponse: 'Esperamos que os materiais de apoio disponibilizados aqui ajudem a esclarecer quaisquer questões que possa ter. Se não encontrar uma resposta para o seu problema, contacte-nos.',
    clinicalSupportHeader: 'Apoio clínico',
    clinicalSupportText: 'Se tiver alguma questão sobre os seus cuidados de saúde, contacte a sua equipa de diabetes.',
    techSupportHeader: 'Apoio técnico e educativo',
    techSupportHeaderText: 'Aqui encontra materiais de apoio e dados de contacto, caso necessite de contactar a nossa equipa de apoio.',
    techMaterialHeader: 'Materiais técnicos:',
    userManual: 'Manual do utilizador do CamAPS FX (é necessário um leitor de PDF)',
    userManualEnglish_mmol_l: 'English',
    userManualCzech_mmol_l: 'Česky',
    userManualDanish_mmol_l: 'Dansk',
    userManualGerman_mg_dl: 'Deutsch',
    userManualGerman_mmol_l: 'Deutsch',
    userManualSpanish_mg_dl: 'Español',
    userManualFrench_mmol_l: 'Français',
    userManualFrench_mg_dl: 'Français',
    userManualItalian_mg_dl: 'Italiano',
    userManualItalian_mmol_l: 'Italiano',
    userManualDutch_mg_dl: 'Nederland',
    userManualDutch_mmol_l: 'Nederland',
    userManualNorsk_mmol_l: 'Norsk',
    userManualPolish_mg_dl: 'Polski',
    userManualFinish_mmol_l: 'Suomi',
    userManualSwedish_mmol_l: 'Svenska',

    previousManualVersions: 'Versões anteriores',
    installationManualHeader: 'Instalar o CamAPS FX (DANA)',
    installationManualEnglish: 'Guia de instalação',
    installationManualGerman: 'Installationsanleitung',
    installationManualFrench: 'Guide d\'installation',
    educationalMaterial: 'Material educativo:',
    onlineTraining: 'Formação para profissionais de saúde:',
    onlineTrainingText: 'Disponibilizada pelo Cambridge Diabetes Education Programme (CDEP)',
    onlineTrainingLink: 'https://www.camdiabtraining.com/account-sign-in.html',
    onlineTrainingText_1: 'Formação online GRATUITA certificada',
    webinarsHeading: 'Webinars',
    webinar_1: 'Apresentação do sistema CamAPS FX',
    webinar_2: 'Começar a utilizar o sistema CamAPS FX',
    webinar_3: 'Otimizar as definições do CamAPS FX',
    webinar_4: 'Formação para professores e pessoal de apoio educativo',
    webinar_5: 'Ajustar o sistema para melhorar o tempo no intervalo-alvo',
    webinar_6: 'Utilizar o CamAPS FX durante a gravidez',
    webinar_7: 'Utilizar o CamAPS FX em bebés, crianças pequenas e crianças',
    webinar_8: 'Utilizar o CamAPS FX em jovens adultos e adultos',
    webinar_9: 'Gerir a atividade física, as refeições e outros acontecimentos da vida',
    webinar_10: 'Terapêutica de insulina em circuito fechado e qualidade de vida',
    webinar_11: 'Terapêutica de circuito fechado e diabetes tipo 1 de longa duração',
    webinar_footnote: '',

    contactDetailsHeader: 'Dados de contacto:',
    contactDetailsText: 'A nossa equipa de apoio está disponível durante o horário de expediente, de segunda a sexta-feira, das 9h00 às 17h00.',
    contactDetailsEmailTitle: 'Envie-nos um e-mail',
    contactDetailsEmail: 'support@camdiab.com',
    contactDetailsEmailFull: 'mailto:support@camdiab.com',
    contactDetailsPhoneTitle: 'Contacte-nos',
    contactDetailsPhone: '020 3695 3780',
    contactDetailsPhoneFull: 'tel:+442036953780',

    eIfuAccess: 'Podem ser solicitadas cópias impressas dos manuais do utilizador ao Apoio ao Cliente. ' +
        'As cópias impressas são gratuitas e serão entregues num prazo aproximado de 3 a 7 dias. ' +
        'Para obter os melhores resultados, utilize o Adobe<sup>®</sup> Reader<sup>®</sup> para consultar os manuais do utilizador da CamDiab.',

    statusPageText: 'Página de estado',
    statusPageLink: 'https://camdiabltd.statuspage.io/',

    installationYpsoPumpHeader: 'Instalar o CamAPS FX',
    installationYpsoPumpText: 'Google Play',
    installationYpsoPumpLink: 'https://play.google.com/store/apps/details?id=com.camdiab.fx_alert.mmoll&hl=en_GB',

    installationYpsoPumpTextIOS: 'App Store',
    installationYpsoPumpLinkIOS: 'https://apps.apple.com/gb/app/camaps-fx-mmol-l/id6504254394',

    danaPumpSupportText: 'Utilizadores de bombas Dana',
    danaPumpSupportTextUK: 'Utilizadores de bombas Dana',
    danaPumpSupportLinkUK: 'https://advancedtherapeutics.org.uk/contact-us/',
    ypsoPumpSupportText: 'Utilizadores da YpsoPump',
    ypsoPumpSupportLink: 'https://www.mylife-diabetescare.com/en/services/customer-care-contact.html',
};
